import { render, staticRenderFns } from "./merchantDeductionAdd.vue?vue&type=template&id=57dcff14&"
import script from "./merchantDeductionAdd.vue?vue&type=script&lang=js&"
export * from "./merchantDeductionAdd.vue?vue&type=script&lang=js&"
import style0 from "./merchantDeductionAdd.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports